// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1laBY","title":"styles_title__K8Dj1"};